import styled from 'styled-components';
import { DatePicker, Flex } from 'antd';
import { maxWidth } from 'config/constants';
import { kccThemeConstants } from 'config/theme/kccTheme/kccTheme';

export const ScheduleHeaderStatusContainer = styled(Flex)`
  ${maxWidth.m} {
    flex-direction: column-reverse;
    gap: 16px;
    align-items: flex-start;
  }

  .ant-btn-icon {
    width: 20px;
    height: 20px;
  }
`;

export const ScheduleSyncStatusContainer = styled(Flex)`
  margin-right: auto;

  ${maxWidth.m} {
    flex-direction: row;
  }
`;

export const ScheduleSyncIconContainer = styled.div`
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: ${kccThemeConstants.SIZE.S200}px;
  height: ${kccThemeConstants.SIZE.S200}px;

  .svg-icon {
    display: flex;
  }
`;

export const ScheduleHeaderFilterContainer = styled(Flex)`
  ${maxWidth.m} {
    flex-direction: column;

    .kcc-theme-range-picker {
      flex: unset;
    }
  }
`;

export const ScheduleRangePickerContainer = styled(Flex)`
  flex: 1;

  .ant-btn:first-child {
    .svg-icon {
      transform: rotate(180deg);
    }
  }

  .svg-icon {
    display: block;
    width: ${(props): number => props.theme.kcc.size.S250}px;
    height: ${(props): number => props.theme.kcc.size.S250}px;
  }
`;

export const ScheduleRangePicker = styled(DatePicker.RangePicker)`
  flex: 1;

  .ant-picker-input {
    flex: 1;
  }
`;
